module.exports = __webpack_public_path__ + "img/wx-public.993069ab.jpg";